import api from "../../services/api";


export default async function getOneMessageDin(idmsg) {
	
	const { data } = await  api.get(`MensajesC/getonedin/${idmsg}`);
	return  data;
}

